/**
 * Voice Tune-Up Lesson
 * Skill Area: Communication
 * Transform generic AI drafts into authentic content
 */

import type { LessonDefinition } from '../types';
import { VOICE_TUNE_UP_AI_PROMPT, VOICE_TUNE_UP_CONTEXT_SCENARIOS } from '../prompts/voice-tune-up.prompt';

export const voiceTuneUp: LessonDefinition = {
  id: 'voice-tune-up',
  title: 'Voice Tune-Up',
  displayTitle: 'Infuse AI Drafts with Organizational Soul',
  subTitle: 'Turn vanilla generic copy into authentic voice.',
  persona: 'Lyra',
  skillArea: 'Communication',
  topicId: 'communication-quality',
  topicTitle: 'Communication Quality & Voice',
  topicDescription: 'Verify outputs, keep your voice authentic, and build reusable comms systems.',
  format: 'tool_lab',
  difficulty: 'Intermediate',
  estimatedMinutes: 10,
  tags: ['voice', 'editing', 'authenticity'],
  dailyEligible: true,
  releasedAt: '2025-03-05T00:00:00.000Z',
  route: '/micro/voice-tune-up',
  storyBeat: 'Lyra teaches you to edit for soul, not just grammar.',
  introPrompt: "AI drafts sound like everyone else. Your voice—the thing that makes your org unique—gets lost. Let's fix that.",
  steps: [
    "Share a draft that sounds too generic",
    "See the three voice layers that make writing authentic",
    "Watch your draft transform through v1 → v2 → v3",
    "Master the improvement pattern for any future content"
  ],
  promptGuidance: 'Paste your draft or describe what needs voice work.',
  contextScenarios: VOICE_TUNE_UP_CONTEXT_SCENARIOS,
  aiPrompt: VOICE_TUNE_UP_AI_PROMPT,
  inputPlaceholder: "Paste your draft or describe what needs voice work...",
  quickPrompts: [
    'Donor thank-you email',
    'Social media post',
    'Newsletter intro',
    'Program description'
  ]
};
